export const TENANT_AUTH_STORAGE_KEY = "saquei_dev_token";
const TOKEN_KEY = TENANT_AUTH_STORAGE_KEY;
const MEMBER_ID_KEY = "saquei_dev_member_id";
const ROLE_KEY = "saquei_dev_role";

export interface AuthState {
    token: string;
    memberId: string;
    role: string;
}

export function loadAuth(): AuthState | null {
    if (typeof localStorage === "undefined") return null;
    const token = localStorage.getItem(TOKEN_KEY);
    const memberId = localStorage.getItem(MEMBER_ID_KEY);
    const role = localStorage.getItem(ROLE_KEY);
    if (!token || !memberId || !role) return null;
    return { token, memberId, role };
}

export function saveAuth(auth: AuthState): void {
    localStorage.setItem(TOKEN_KEY, auth.token);
    localStorage.setItem(MEMBER_ID_KEY, auth.memberId);
    localStorage.setItem(ROLE_KEY, auth.role);
}

export function clearAuth(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(MEMBER_ID_KEY);
    localStorage.removeItem(ROLE_KEY);
}
